import FieldDefs from './SearchKeysFieldDefs'
import {doLangFields} from '../../lib/ks-tools'
import {Listeners} from '../../constants/listeners'

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data () {
        return {
            fields: doLangFields(this, "lang.report.searchkeys", FieldDefs),
            sortOrder: [
                {
                    field: 'superwsk',
                    direction: 'desc'
                }
            ],
            viewMode: true,
            adultMode: true
        }
    },
    computed: {
        getApiUrl(){
            // viewMode — галочка «Нечёткий поиск»; strict=true — точный поиск
            return '/report/system_keywords?strict=' + !this.viewMode + '&hideadult=' + this.adultMode;
        },
        self() {
            return this;
        },
    },
    watch: {
        // Режимы ищут по-разному (нечёткий: список фраз, точный: одна фраза), поэтому при переключении
        // очищаем поле и модель фильтра; таблица не перезапрашивается — без фильтра набор данных один
        viewMode(){
            this.$emitter.emit(Listeners.KS_FILTER_SIMPLE_CLEAR);
        }
    },




}
